import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the result of the finalize content command.
 */
export type PrepareContentForFinalizationCommandResult = {
	success: boolean;
	content: any;
};

/**
 * A command sent by a bridge API client to instruct the owner to perform
 * any final actions on the content, e.g., intended to be used before
 * finalizing an AIFC page (add to space) so that a draft sync can
 * be performed first.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to finalize the current content of a content type.
 */
export const PrepareContentForFinalizationCommand = createCommand<
	CommandProperties,
	PrepareContentForFinalizationCommandResult
>('prepare-content-for-finalization-command');
